import styled from 'styled-components';

export const PageOverlayLoader = styled.div<{
  isShowing: boolean;
}>`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 999999;
  background-color: #e9e9e9;
  opacity: ${({ isShowing }) => (isShowing ? 0.6 : 0)};
  top: 0;
  left: 0;
  visibility: ${({ isShowing }) => (isShowing ? 'visible' : 'hidden')};
  transition: 0.2s;
`;

export const ExportLoaderContainer = styled.div<{
  isShowing: boolean;
}>`
  width: 500px;
  height: 500px;
  background-color: #ffffff;
  display: ${({ isShowing }) => (isShowing ? 'flex' : 'none')};
  flex-direction: column;
  position: fixed;
  z-index: 9999999;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  text-align: center;
  justify-content: center;
`;
